// extracted by mini-css-extract-plugin
export default {"wrapper":"shareIcons__wrapper__JjvD2","item":"shareIcons__item__NOtK3"};